import type { SupportedCurrencies } from '../components/Utility/VoPayApi/VoPayApi.types';

const usCurrencyOnly: { [key in SupportedCurrencies]?: string } = {
  USD: 'USD',
};

export default usCurrencyOnly;
